{
	"title": "Brak dostępu (403)",
	"description": "Nie masz wymaganych uprawnień, aby uzyskać dostęp do tej strony. Upewnij się, że jesteś zalogowany(-a) na konto z odpowiednimi uprawnieniami. Wyczyszczenie danych przeglądarki może również rozwiązać problem. Jeśli nadal potrzebujesz dostępu, skontaktuj się z administratorem systemu.",
	"secondaryButtonTitle": "Wyloguj się"
}
